import apiClient from './axios';

export interface SubscriptionFeatures {
  maxQuestionsPerDomain: number; // -1 = unlimited
  timedQuizAccess: boolean;
  analyticsAccess: boolean;
  allDomainsAccess: boolean;
  examSimulation: boolean;
  studyPlanAccess: boolean;
}

export interface SubscriptionStatus {
  tier: 'free' | 'pro_monthly' | 'pro_yearly';
  status: 'active' | 'canceled' | 'past_due' | 'trialing' | 'expired';
  currentPeriodEnd?: string;
  cancelAtPeriodEnd?: boolean;
  features: SubscriptionFeatures;
  ownedPacks?: string[];
}

export type PriceType = 'monthly' | 'yearly' | 'comptia_pack' | 'aws_pack';

/**
 * Get the current user's subscription status and feature flags
 */
export const getSubscriptionStatus = async (): Promise<SubscriptionStatus> => {
  const response = await apiClient.get<{ success: boolean; subscription: SubscriptionStatus }>(
    '/api/stripe/subscription-status'
  );
  return response.data.subscription;
};

/**
 * Create a Stripe Checkout session and return the URL to redirect to
 */
export const createCheckoutSession = async (priceType: PriceType): Promise<string> => {
  const response = await apiClient.post<{ success: boolean; url: string }>(
    '/api/stripe/create-checkout-session',
    { priceType }
  );
  return response.data.url;
};

/**
 * Create a Stripe Customer Portal session for managing billing
 */
export const createPortalSession = async (): Promise<string> => {
  const response = await apiClient.post<{ success: boolean; url: string }>(
    '/api/stripe/create-portal-session'
  );
  return response.data.url;
};
